<template>
  <div>
    <div class="recruit-hero">
      <b-img
        src="../assets/images/maids.png"
        alt="รับสมัครแม่บ้านออนไลน์ รายได้ดี ทำงานอิสระ"
        class="position-maids"
      ></b-img>
      <b-container>
        <div class="big-screen-min-h">
          <div class="bg-recruit-none">
            <b-img
              src="../assets/images/recruit_4.png"
              alt="ด่วน! รับสมัครแม่บ้าน หลายอัตรา"
              class="d-block mx-auto recruit-title small-mt-4"
            ></b-img>
            <div class="mt-4 bg-recruit">
              <div
                class="recruit-checklist mt-3"
                v-for="(item, index) in [
                  'รายได้มากกว่า 20,000-40,000 บาท',
                  'งานอิสระ เลือกเวลาทำงานที่สะดวกได้',
                  'ไม่ต้องหาลูกค้าเอง มีงานให้ทุกวัน',
                  'จ่ายเงินตรงเวลาทุกสัปดาห์',
                  'สมัครงานฟรี ยูนิฟอร์มฟรี !',
                ]"
                :key="index"
              >
                <b-img
                  src="../assets/images/recruit_checklist.png"
                  alt="checklist คุณสมบัติของผู้สมัคร"
                ></b-img>
                <span> {{ item }} </span>
              </div>
              <div class="middle-left">
                <b-img
                  src="../assets/images/line-arrow.png"
                  alt="สมัครคลิกไลน์"
                  class="line-arrow"
                ></b-img>
                <a href="https://line.me/R/ti/p/@bluuupro">
                  <b-img
                    src="../assets/images/recruit_line_2.png"
                    alt="สมัครคลิกไลน์"
                    class="d-block recruit-line-2"
                  ></b-img>
                </a>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </div>

    <div class="bg-recruit-3">
      <b-container align-v="center ">
        <b-row align-h="center my-5">
          <b-img
            fluid
            src="../assets/images/recruit_5.png"
            alt="รับสมัครแม่บ้าน รายได้สูง 2 ชม. 384 บาท 3 ชม. 559 บาท 4 ชม. 683 บาท 6 ชม. 937 บาท 8 ชม. 1,237 บาท"
            class="d-block mx-auto recruit-data"
          ></b-img>
        </b-row>
      </b-container>
    </div>

    <b-container align-v="center" class="-mt-24">
      <b-row align-h="center my-5">
        <h4 class="text-center header-text-3 mt-4">ชีวิตจริงของแม่บ้าน Bluuu</h4>
        <slick
          class="slick-class testimonial d-flex justify-content-center"
          :options="slickTestimonialOptions"
          style="width: 100%"
        >
          <div
            v-for="(item, idx) in testimonials"
            :key="idx"
            class="carousel-slide"
            style="margin-top: 3rem; background: #005dff; border-radius: 16px"
          >
            <div class="d-flex justify-content-center mt-dsc">
              <MaidAvatar :url="item.avatar" :level="item.level" class="mr-2" size="xl" />
            </div>
            <div
              class="text-center mx-auto flex-1"
              style="
                max-width: 400px;
                display: flex;
                flex-direction: column;
                flex: 1 1 auto;
                justify-content: flex-start;
              "
            >
              <h5 class="text-name p-1">
                {{ item.name }}
              </h5>
              <div class="mb-2 testimonial-quote px-3">
                {{ item.quote }}
              </div>
              <div v-if="item.link" class="p-3">
                <div class="video-embed-wrapper">
                  <iframe
                    :src="youtubeEmbedUrl(item.link)"
                    width="100%"
                    height="215"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              <div style="white-space: pre-line; min-height: 150px">
                <p class="text-style testimonial-text p-1">{{ item.text }}</p>
              </div>
              <div class="font-italic text-end p-3 " style="color: #fff">
                — {{ item.nickname }}
              </div>
            </div>
          </div>
        </slick>
      </b-row>
    </b-container>

    <div class="bg-recruit-5">
      <img src="../assets/images/Free.png" alt="Free" class="position-free" />
      <b-col cols="12 ">
        <div class="text-center header-text-3 text-white">อบรมแม่บ้านก่อนเริ่มงาน</div>
        <div class="text-center header-text text-white">พร้อมแจกชุดยูนิฟอร์ม+ผ้าทำความสะอาด</div>
      </b-col>
    </div>

    <b-container>
      <b-row align-h="center" class="my-5">
        <b-col cols="12" md="6">
          <b-img
            fluid
            src="../assets/images/FreeTraining-1.png"
            alt="อบรมแม่บ้านก่อนเริ่มงาน พร้อมแจกชุดยูนิฟอร์ม+ผ้าทำความสะอาด"
            class="d-block mx-auto recruit-free mt-4"
          ></b-img>
        </b-col>
        <b-col cols="12" md="6">
          <b-img
            fluid
            src="../assets/images/FreeTraining-2.png"
            alt="อบรมแม่บ้านก่อนเริ่มงาน พร้อมแจกชุดยูนิฟอร์ม+ผ้าทำความสะอาด"
            class="d-block mx-auto recruit-free mt-4"
          ></b-img>
        </b-col>
      </b-row>
    </b-container>

    <div class="bg-recruit-6">
      <b-container>
        <b-row class="">
          <b-col cols="12">
            <div class="text-center header-text-3 text-white mt-2 mb-5">
              สมัครเป็นแม่บ้าน Bluuu <span class="sm-show"><br /></span> ไม่ยากอย่างที่คิด
            </div>
            <div class="recruit-card">
              <p>คุณสมบัติแม่บ้าน</p>
              <div
                class="card-list"
                v-for="(item, index) in [
                  'สัญชาติไทย',
                  'รับไม่จำกัดอายุ',
                  'สามารถเดินทางได้ในพื้นที่กรุงเทพและปริมณฑล',
                  'ไม่มีประวัติอาชญากรรม (ไม่มีข้อยกเว้นรวมถึงการพนัน ฯลฯ)',
                  'ใช้โทรศัพท์มือถือระบบ “แอนดรอยด์” ไม่ใช่ “ไอโฟน” (สำหรับติดตั้งแอปพลิเคชัน bluuu)',
                ]"
                :key="index"
              >
                <b-img src="../assets/images/star-icon.png" alt="star icon"></b-img>
                <span> {{ item }} </span>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="recruit-card">
              <p>วิธีการสมัครแม่บ้าน</p>
              <div class="d-flex justify-content-center">
                <a @click="clickLine" role="button" class="card-explain" style="cursor: pointer"
                  >กรุณาส่งข้อมูลต่อไปนี้ทาง ไลน์: @bluuupro</a
                >
              </div>
              <div
                class="card-list"
                v-for="(item, index) in [
                  'ชื่อ นามสกุล',
                  'เบอร์',
                  'ที่อยู่ปัจจุบัน',
                  'ประสบการณ์แม่บ้าน',
                  'ปัจจุบันทำงานกี่วันต่อสัปดาห์',
                  'สามารถรับงานจากเราได้กี่วันต่อสัปดาห์',
                  'ยืนยันไม่มีประวัติอาชญากรรมใดๆ',
                ]"
                :key="index"
              >
                <div style="position: relative; display: inline-block">
                  <b-img src="../assets/images/star-icon-2.png" alt="star icon"></b-img>
                  <div class="index-above">
                    <span class="index-number">{{ index + 1 }}</span>
                  </div>
                </div>
                <span> {{ item }} </span>
              </div>
              <div style="font-size: 14px; color: #005dff">
                คำเตือน:
                บริษัทตรวจสอบประวัติอาชญากรรมของผู้สมัครทุกคนก่อนที่จะรับเข้าทำงานและบริษัทจะไม่รับผู้สมัครที่มีประวัติอาชญากรรมทุกประเภท
                กรุณาแจ้งข้อมูลทุกอย่างตามความจริง
              </div>
              <div class="middle">
                <b-img
                  src="../assets/images/line-arrow.png"
                  alt="สมัครคลิกไลน์"
                  class="line-arrow"
                ></b-img>
                <a @click="clickLine" role="button" style="cursor: pointer">
                  <b-img
                    src="../assets/images/recruit_line_2.png"
                    alt="สมัครคลิกไลน์"
                    class=" recruit-line mx-auto"
                  ></b-img>
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Articles type="maid" />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import Articles from '../components/Articles'
import MaidAvatar from '../components/MaidAvatar'
import Slick from 'vue-slick'
@Component({
  components: {
    Articles,
    MaidAvatar,
    Slick,
  },
})
export default class RecruitMaid extends Vue {
  slickTestimonialOptions = {
    slidesToShow: 3,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  testimonials = [
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/13644/17144954638.jpg',
      level: 'Super Maid',
      name: '"Su" Supattar Pimkhot',
      quote: `“ถ้าให้เลือกกลับไปทำงานประจำไม่เอาค่ะ ทำงานที่นี่มีเวลาอยู่กับลูกเยอะมากขึ้น”`,
      text: `“ทำงานแม่บ้านออนไลน์ที่ Bluuu ที่แรก ทำงานประจำไม่มีเวลาให้ครอบครัวเลยค่ะ พอมาทำเป็นแม่บ้านออนไลน์มีเวลาให้ครอบครัวเยอะมากขึ้นเป็นเท่าตัวเลยได้อยู่กับลูก ได้กลับบ้านที่ต่างจังหวัดบ่อยขึ้น งานอิสระ รายได้ดีค่ะ”`,
      nickname: 'แม่บ้านสุ',
      link: 'https://www.youtube.com/watch?v=khHSF7LTdkA',
    },
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/13642/17144823042.jpg',
      level: 'Super Maid',
      name: '"Ying" Nopharat Jankajang',
      quote: `“ ถ้ารู้ว่ามีงานแม่บ้านออนไลน์แบบนี้มาทำตั้งนานแล้วค่ะ รายได้ดีมีเวลาดูแลครอบครัว ”`,
      text: `“ มีคุณพ่อที่ป่วยแล้วต้องพาไปโรงพยาบาลบ่อยถ้าทำงานประจำก็คงลาบ่อยๆ ไม่ได้ ตอนนี้มาทำแม่บ้านออนไลน์มีเวลาดูแลพ่อได้เต็มที่ ตัดสินใจถูกที่มาสมัครงานกับ Bluuu ทั้งมีเวลามากขึ้น งานอิสระ ทำงานได้สบายใจ แฮปปี้มากค่ะ ”`,
      nickname: 'แม่บ้านหญิง',
      link: 'https://www.youtube.com/watch?v=oxKAuyIbS88',
    },
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/10887/17023836943.jpg',
      level: 'Super Maid',
      name: '"PHA" TINNA CINNOY',
      quote: `“ตอนแรกพี่ก็คิดว่าพี่จะทำงานนี้ไม่ได้แต่ก็ทำได้เพราะเป็นงานที่เราชอบ”`,
      text: `“เป็นแม่บ้าน Bluuu ดีตรงที่มีเวลาทำอย่างอื่นได้เยอะ บอสใจดี แอดมินก็ดีสุดๆ ตอบไลน์แม่บ้านรวดเร็วทันใจ มีปัญหาอะไรช่วยแก้ได้ทันที ทำงานที่Bluuu รายได้ถือว่าสูง ที่สำคัญเงินออกตรงเวลามาก ชอบมากค่ะ จะตั้งใจทำงานให้ดีที่สุดค่ะ ”`,
      nickname: 'แม่บ้านภา',
      link: 'https://www.youtube.com/watch?v=JszvJp9X5AM',
    },
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/7676/16856841860.jpg',
      level: 'Super Maid',
      name: '"Ben" Nutkrita Bunsong',
      quote: ` “ มาทำงานที่ Bluuu สามารถช่วยปลดหนี้ กยศ.และมีเงินไปช่วยดูแลครอบครัวได้ ”`,
      text: `“ ตอนทำงานแม่บ้านประจำเงินเดือนไม่ถึง 15,000.-  พอเปลี่ยนมาทำงานแม่บ้านออนไลน์ที่ Bluuu รายได้สูงกว่างานประจำ 3-4 เท่าตัว มีเงินเหลือเก็บเหลือใช้ มีเวลาแบ่งให้ครอบครัวได้แล้วก็มีความสุขมากขึ้นด้วยค่ะ ”`,
      nickname: 'แม่บ้านเบญ',
      link: 'https://www.youtube.com/watch?v=kwtKL5w-6SQ',
    },
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/14042/17159560468.jpg',
      level: 'Super Maid',
      name: '"Bon" Ubon Bunprakob',
      quote: `“ บริษัทนี้ดีมากค่ะ ชีวิตดีขึ้นเยอะมากเลยเปลี่ยนจากหน้ามือเป็นหลังมือ ”`,
      text: `“ จากที่เคยติดหนี้เกือบล้าน ตอนนี้หนี้ลดลงไปเยอะมาก มีเงินกินมีเงินใช้สบายมือขึ้นเยอะ ไม่ต้องลำบากเหมือนเมื่อก่อน ได้มีเงินไปลงของขายในเวลาว่างด้วย เพราะที่ Bluuu เงินออกเร็วทันใช้ไม่เคยจ่ายเงินช้า มีเงินมาหมุนได้ตลอด ”`,
      nickname: 'แม่บ้านอุบล',
      link: 'https://www.youtube.com/watch?v=0fSCo_eaaL4',
    },
    {
      avatar: 'https://storage.googleapis.com/bluuu-prod-profile-images/10890/17024372967.jpg',
      level: 'Super Maid',
      name: '"Picha" Phithayarat Penanam',
      quote: `“ ทำแม่บ้านออนไลน์ดีกว่า รายได้ดี มีงานให้ทุกวันแล้วก็งานอิสระด้วยค่ะ  ”`,
      text: `“ มาสมัครงานที่ Bluuu ด้วยตัวเอง ทำงานที่นี่รู้สึกดีค่ะ ชอบมาก เพราะงานมันอิสระ อยากจะไปไหนก็ได้ รายได้ก็ดี ถ้าเราขยันทำงานเราก็ได้เงินเยอะ ถ้าเราขี้เกียจเราก็ได้เงินน้อย ตอนนี้มีเงินส่งลูกเรียนหนังสือได้สบายมาก ”`,
      nickname: 'แม่บ้านพิชา',
      link: 'https://www.youtube.com/watch?v=3mXLfRFef98',
    },
  ]

  clickLine() {
    window.open('https://line.me/R/ti/p/@bluuupro', '_blank')
  }

  youtubeEmbedUrl(link) {
    const match = link.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/)
    return match ? `https://www.youtube.com/embed/${match[1]}` : ''
  }
}
</script>

<style lang="scss" scoped>
.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.big-screen-min-h {
  @media (min-width: 1200px) {
    min-height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.bg-recruit-2 {
  background: #005dff;
  padding: 30px;
  border-radius: 36px;

  @media (max-width: 767px) {
    padding: 18px;
    border-radius: 20px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    border-radius: 12px;
  }
}

.padding-small {
  @media (max-width: 480px) {
    padding: 0 10px;
  }
}

.relative {
  position: relative;
}

.index-above {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 2;
}

.index-number {
  color: white !important;
}

.-mt-24 {
  margin-top: -120px !important;
}

.bg-recruit-3 {
  background: url('../assets/images/confetti.png');
  background-repeat: repeat-x;
  height: auto;
  background-size: 1200px auto;
  padding: 30px 16px;
}

@media (max-width: 1200px) {
  .bg-recruit-3 {
    background-size: 1000px auto;
  }
}

.bg-recruit-5 {
  width: 100%;
  background: #005dff;
  padding: 16px 0px;
  position: relative;
}

.bg-recruit-6 {
  width: 100%;
  background: #005dff;
  padding: 36px;
  position: relative;

  @media (max-width: 767px) {
    padding: 24px;
  }
  @media (max-width: 480px) {
    padding: 12px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 30px;
    width: 160px;
    height: 160px;
    background: url('../assets/images/element_card-2.png') no-repeat;
    background-size: contain;
    pointer-events: none;
    z-index: 0;
  }

  &::before {
    right: 10px;
  }

  &::after {
    left: 10px;
    transform: scaleX(-1);
  }

  @media (max-width: 1199px) {
    &::before,
    &::after {
      width: 140px;
      height: 140px;
    }
  }
  @media (max-width: 767px) {
    &::before,
    &::after {
      width: 100px;
      height: 100px;
    }
    &::before {
      right: 6px;
    }
    &::after {
      left: 6px;
    }
  }
  @media (max-width: 480px) {
    &::before,
    &::after {
      width: 60px;
      height: 60px;
      top: 10px;
    }
    &::before {
      right: 4px;
    }
    &::after {
      left: 4px;
    }
  }
}

.position-free {
  position: absolute;
  bottom: -60px;
  left: 70%;
  width: 120px;

  @media (max-width: 1199px) {
    left: 75%;
    width: 100px;
    bottom: -55px;
  }

  @media (max-width: 767px) {
    left: 75%;
    width: 80px;
    bottom: -40px;
  }

  @media (max-width: 480px) {
    width: 80px;
    bottom: -40px;
  }
}

.padding-small {
  @media (max-width: 480px) {
    padding: 0 10px;
  }
}

.header-text {
  font-size: clamp(1rem, 4vw, 2rem);
  font-weight: bold;
  color: #005dff;
}

.header-text-2 {
  font-size: clamp(1rem, 4vw, 2rem);
  font-weight: bold;
  color: #005dff;
}

.header-text-3 {
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: bold;
  color: #005dff;
}

.sm-show {
  display: none;
  @media (max-width: 576px) {
    display: inline;
  }
}

.testimonial ::v-deep {
  .slick-dots:not(#_) {
    li button:before {
      background-color: #73757a;
    }
    li.slick-active button:before {
      border: none !important;
      background-color: #005dff !important;
    }
  }
  .slick-slide {
    margin: 20px;
    padding-top: 10px;
  }
  .slick-arrow::before {
    color: #005dff;
  }
}

.slick-class ::v-deep {
  .slick-prev,
  .slick-next {
    width: auto;
    height: auto;
  }
}

::v-deep .slick-arrow::before {
  font-size: 50px;
}

::v-deep .slick-prev {
  left: -70px;
}

::v-deep .slick-next {
  right: -70px;
}

.testimonial-card {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 14px;
  position: relative;
}

.articles-card {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  position: relative;
  height: 350px;
  overflow: hidden;
  img {
    height: 45%;
    object-fit: cover;
  }
  .card-title {
    text-decoration: none;
    font-size: 16px;
    margin-bottom: 0 !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  span {
    font-size: 14px;
    font-weight: normal;
  }

  .card-text {
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .read_more {
    text-decoration: underline;
    color: #005dff;
    font-size: 14px;
    font-weight: 500;
  }
}

.testimonial-textarea-div {
  border-radius: 14px;
  background-color: white;
  box-shadow: 0px -5px 10px 2px white;
  padding-top: auto;
  padding-bottom: auto;
  height: auto;
  position: relative;
}

.testimonial-textarea {
  padding: 20px;
  height: 300px;
}

.testimonial-img {
  position: absolute;
  left: 50%;
  top: 0%;
  width: 30%;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background-color: white;
}

.testimonial-img-space {
  width: 30%;
  aspect-ratio: 2 / 1;
}

.testimonial-img img {
  aspect-ratio: 1 / 1;
  object-fit: cover;
  width: 100%;
  border-radius: 100%;
}

.testimonial-namearea {
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.testimonial-double {
  position: absolute;
  width: 25px;
  aspect-ratio: 1.2 / 1;
}

.recruit-free {
  width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 1199px) {
  ::v-deep .slick-prev {
    left: -50px;
  }

  ::v-deep .slick-next {
    right: -50px;
  }

  .testimonial-textarea {
    height: 320px;
  }

  .maid-slick ::v-deep {
    .slick-arrow::before {
      font-size: 30px;
    }
  }
}

@media screen and (max-width: 993px) {
  .testimonial-textarea {
    height: 390px;
  }
}

@media screen and (max-width: 767px) {
  .slick-class {
    width: 80% !important;
  }

  ::v-deep .slick-arrow::before {
    font-size: 30px !important;
  }

  ::v-deep .slick-prev {
    left: -30px;
  }

  ::v-deep .slick-next {
    right: -30px;
  }

  .testimonial-textarea {
    height: 340px;
  }
}
@media screen and (max-width: 540px) {
  .testimonial-textarea {
    height: 360px;
  }
}
@media screen and (max-width: 424px) {
  .testimonial-textarea {
    height: 430px;
  }
}
@media screen and (max-width: 350px) {
  .testimonial-textarea {
    height: 500px;
  }
}

.mt-dsc {
  margin-top: -3rem;
}

.mt-inc {
  margin-top: 3rem;
}

.recruit-hero {
  margin-top: 70px;
  background: url('../assets/images/bg-new3-3.png') no-repeat;
  background-size: cover;
  background-position: center;
  padding: 30px 0;
  position: relative;
  overflow: hidden;
  .container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div {
    h4,
    h5 {
      line-height: 1.5em;
    }
    h5 {
      font-size: 20px;
    }
  }

  @media (max-width: 767px) {
    margin-top: 56px;
    // padding: 18px 0;
  }
}

.position-maids {
  position: absolute;
  bottom: 0;
  right: 100px;
  width: 650px;

  @media (max-width: 1600px) {
    right: 0px;
    width: 550px;
  }

  @media (max-width: 1360px) {
    right: 0px;
    width: 400px;
  }

  @media (max-width: 1024px) {
    right: 0px;
    width: 350px;
  }

  @media (max-width: 767px) {
    right: -40px;
    width: 300px;
  }

  @media (max-width: 600px) {
    right: 0px;
    width: 270px;
  }

  @media (max-width: 480px) {
    right: -20px;
    width: 250px;
  }

  @media (max-width: 450px) {
    right: -20px;
    width: 200px;
  }

  @media (max-width: 400px) {
    right: -30px;
    width: 180px;
  }

  @media (max-width: 350px) {
    right: -40px;
    width: 150px;
  }
}

.text-name {
  font-size: clamp(0.9rem, 3vw, 1.25rem);
  font-weight: bold;
  color: #ffd726;
  margin-bottom: 10px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.testimonial-quote {
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  color: #fff;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.text-style {
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  font-weight: 400;
  line-height: 1.5;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}

.text-end {
  font-weight: 400;
  font-size: 14px;
  text-align: end;
}

.bg-recruit {
  background: #ffffffcf;
  padding: 30px;
  border-radius: 18px;
  @media (max-width: 767px) {
    padding: 18px;
    border-radius: 20px;
  }
}

.flex-sm-column {
  @media (max-width: 576px) {
    flex-direction: column !important;
  }
}

.recruit-title {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-top: -20px;
}

.small-mt-4 {
  @media (max-width: 1024px) {
    margin-top: 1rem !important;
  }
}

.recruit-line-2 {
  width: 80%;
  max-width: 300px;
  display: block;

  @media (max-width: 767px) {
    max-width: 275px;
  }

  @media (max-width: 576px) {
    max-width: 250px;
  }

  @media (max-width: 400px) {
    max-width: 200px;
  }
}

.recruit-line {
  width: 100%;
  max-width: 250px;
  display: block;
}

.middle-left {
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    justify-content: flex-start;
  }
}

.middle {
  margin-top: 16px;
  margin-left: -30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 576px) {
    margin-left: -10px;
  }
}

.line-arrow {
  width: 50px;
  height: auto;
  margin-right: 10px;
  @media (max-width: 576px) {
    width: 30px;
    margin-right: 6px;
  }
}

.recruit-data {
  width: 100%;
  margin: 0 auto;
  max-width: 600px;
  padding: 48px;

  @media (max-width: 767px) {
    max-width: 100%;
    padding: 24px;
  }
}

.recruit-checklist {
  display: flex;
  align-items: center;
  span {
    font-size: clamp(1rem, 4vw, 24px);
    font-weight: bold;
    color: #005dff !important;
    text-shadow: 1px 1px 0 #8db1f3;
    @media (max-width: 576px) {
      font-size: 1rem;
      text-shadow: 0.7px 0.7px 0 #8db1f3;
    }
  }
  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    @media (max-width: 576px) {
      width: 28px;
      height: 28px;
    }
  }
}

.video-embed-wrapper {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 1.5px 6px rgba(0, 93, 255, 0.08);
  margin: 0 auto;
  max-width: 400px;
}
.video-embed-wrapper iframe {
  display: block;
  border: none;
}

.carousel-slide {
  margin-top: 3rem;
  flex: 1 1 0;
  min-width: 0;
  background: #005dff;
  border-radius: 16px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 5px;
    left: 5px;
    transform: scaleX(-1);
    width: 60px;
    height: 60px;
    background: url('../assets/images/element_card.png') no-repeat;
    background-size: contain;
  }
  &::after {
    content: '';
    position: absolute;
    top: 5px;
    right: 5px;
    width: 60px;
    height: 60px;
    background: url('../assets/images/element_card.png') no-repeat;
    background-size: contain;
  }
}

.recruit-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: linear-gradient(
    to right,
    #7daa35 0%,
    #7daa35 33%,
    #f3b739 33%,
    #f3b739 66%,
    #fb6107 66%,
    #fb6107 100%
  );
  border-radius: 0 0 8px 8px;
}

.recruit-card {
  padding: 24px;
  padding-top: 30px;
  border-radius: 16px;
  border-color: #005dff;
  background-color: #fff;
  border-width: 4px;
  border-style: solid;
  position: relative;
  max-width: 900px;
  margin: 20px auto;
  p {
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 28px;
    width: 100%;
    color: #005dff;
    text-shadow: 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff, 0 0 7px #ffffff,
      0 0 7px #ffffff;
    text-align: center;

    @media screen and(min-width: 425px) {
      font-size: 30px;
    }
    @media screen and(min-width: 768px) {
      font-size: 32px;
    }
    @media screen and(min-width: 1440px) {
      font-size: 36px;
    }
  }
  .card-list {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    span {
      font-size: 18px;
      font-weight: 500;
      color: #1338e9;
    }
  }

  .card-explain {
    border-radius: 10px;
    font-weight: bold;
    color: #fd6924;
    text-align: center;
    margin: 10px auto;
    font-size: 18px;
    width: auto;
  }
}
</style>
